import { render, staticRenderFns } from "./monthly_product_compare.vue?vue&type=template&id=ef5a4fd6&scoped=true"
import script from "./monthly_product_compare.vue?vue&type=script&lang=js"
export * from "./monthly_product_compare.vue?vue&type=script&lang=js"
import style0 from "./monthly_product_compare.vue?vue&type=style&index=0&id=ef5a4fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a4fd6",
  null
  
)

export default component.exports